// @ts-nocheck
import styled from 'styled-components';

export const SummaryCampaignItemDetailsTableStyle = styled.div`
  width: 100%;
  margin-top: 16px;
  display: flex;
  flex-direction: column;
  .itemLineDetailsTable {
    .compactItems {
      white-space: nowrap;
      width: 170px;
    }
    table {
      thead,
      tbody {
        tr {
          line-height: 16px;
          font-family: ${props => props.theme.fontRegular}, serif;
          font-size: ${props => props.theme.fontSizeS};
          gap: 8px;
          td {
            padding: 0;
            .itemLineChartDetail__bottomMetricLabels {
              box-sizing: content-box;
            }
          }
          th {
            padding: 0;
            justify-content: left;
            font-size: ${props => props.theme.fontSizeXS};
            font-family: ${props => props.theme.fontSemiBold};
          }
        }
      }
    }
    .emptyState {
      i::before,
      span {
        color: ${props => props.theme.uiColors.reportingTextColor};
      }
    }
  }
`;
